export default __webpack_public_path__ + "static/lframe-determine-rate-755f613f5c305dfff4aa69220fdd6b24.png";